import React, { Component } from "react";
import { NHPublic, NHStudent, NHAdmin, NHSegreteria, NHEditor, NHRevisore, NHSegreteriaIUL } from "components/navigation";
import { NHSteward } from "components/navigation/NHSteward";
import { USER_ROLES } from "const";

export class NavHeader extends Component {


  loadNHComponent = (isLoggedIn, roles) => {
   
    if (!isLoggedIn) {
      return <NHPublic />
    }

    if (isLoggedIn && roles === USER_ROLES.STUDENT) {
      return <NHStudent
        user={this.props.user}
        logout={this.props.logout}
      />
    }

    if (isLoggedIn && roles === USER_ROLES.ADMIN) {
      return <NHAdmin
        logout={this.props.logout}
      />
    }

    if (isLoggedIn && roles === USER_ROLES.SEGRETERIA) {
      return <NHSegreteria
        logout={this.props.logout}
      />
    }

    if (isLoggedIn && roles === USER_ROLES.SEGRETERIA_IUL) {
      return <NHSegreteriaIUL
        logout={this.props.logout}
      />
    }

    if (isLoggedIn && roles === USER_ROLES.EDITOR) {
      return <NHEditor
        logout={this.props.logout}
      />
    }

    if (isLoggedIn && (roles === USER_ROLES.REVISOR || roles === USER_ROLES.ADMIN_REVISOR)) {
      return <NHRevisore logout={this.props.logout} />;
    }

    if (isLoggedIn && roles === USER_ROLES.STEWARD) {
      return <NHSteward
        logout={this.props.logout}
      />
    }

  }//loadNHComponent


  render() {

    const { isLoggedIn, roles } = this.props;

    return (
      <>
        {this.loadNHComponent(isLoggedIn, roles)}
      </>
    );
  }
}